export default (process.env.NODE_ENV === "production"
  ? "https://imsg-api.lawrencewhiteside.com"
  : "http://localhost:3000");
